import { all, takeEvery, fork, call, put } from 'redux-saga/effects';
import axios from 'axios';
import isFunction from 'lodash/isFunction';

import actions from './actions';
import { handleError } from '../../errorHandler';
import { API_HOST } from '../../constants';

const STATISTICS_DATA_REPORT_API_URL = `${API_HOST}/api/statisticsDataReport`;

function* triggerUpdateStatisticsDataReport() {
  yield takeEvery(actions.TRIGGER_UPDATE_STATISTICS_DATA_REPORT, function* (action) {
    const { reportName, dataId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'put'],
        `${STATISTICS_DATA_REPORT_API_URL}/${reportName}/${dataId}/triggerUpdate`,
        [],
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data);
      }
    } catch (error) {
      yield handleError(error);
    } finally {
      yield put({ type: actions.TRIGGER_UPDATE_STATISTICS_DATA_REPORT_ENDED });
    }
  });
}

function* getStatisticsDataReportResult() {
  yield takeEvery(actions.GET_STATISTICS_DATA_REPORT_RESULT, function* (action) {
    const { reportName, dataId, onSuccess } = action;
    try {
      const res = yield call(
        [axios, 'get'],
        `${STATISTICS_DATA_REPORT_API_URL}/${reportName}/${dataId}`,
      );
      if (isFunction(onSuccess)) {
        yield call(onSuccess, res.data.data);
      }
    } catch (err) {
      yield handleError(err);
    } finally {
      yield put({ type: actions.GET_STATISTICS_DATA_REPORT_RESULT_ENDED });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(triggerUpdateStatisticsDataReport), fork(getStatisticsDataReportResult)]);
}
